import { Grid, useTheme } from '@mui/material';
import SuiBox from '@upheal/design-system/components/legacy/Sui/SuiBox';
import SuiTypography from '@upheal/design-system/components/legacy/Sui/SuiTypography';
import PageLayout from '@upheal/shared/components/shared/LayoutContainers/PageLayout';
import type { RouteComponentProps } from 'react-router-dom';

type Props = RouteComponentProps<{ code: string }>;

function ErrorGeneric({ match }: Props) {
    const { code } = match.params;
    const theme = useTheme();
    const { d1, d3, d4, d5 } = theme.typography;

    const title = (code: string) => {
        switch (code) {
            case '400':
                return 'Link has expired';
            default:
                return 'Something went wrong';
        }
    };

    const description = (code: string) => {
        switch (code) {
            case '400':
                return 'Please reach back to get a new invitation.';
            default:
                return 'Please try again later. If the problem persists, please let us know.';
        }
    };

    return (
        <PageLayout>
            <SuiBox height="100vh">
                <Grid
                    container
                    spacing={3}
                    justifyContent="center"
                    alignItems="center"
                    sx={{ height: '100%' }}
                >
                    <Grid
                        container
                        alignItems="center"
                        size={{
                            xs: 11,
                            sm: 9,
                        }}
                    >
                        <Grid
                            size={{
                                xs: 12,
                                lg: 12,
                            }}
                        >
                            <SuiBox
                                fontSize={{
                                    xs: d5.fontSize,
                                    sm: d4.fontSize,
                                    md: d3.fontSize,
                                    lg: d1.fontSize,
                                }}
                                lineHeight={1.2}
                            >
                                <SuiTypography
                                    variant="inherit"
                                    color="warning"
                                    textGradient
                                    fontWeight="bold"
                                >
                                    Error {code}
                                </SuiTypography>
                            </SuiBox>
                            <SuiTypography
                                variant="h2"
                                color="body"
                                fontWeight="bold"
                            >
                                {title(code)}
                            </SuiTypography>
                            <SuiBox mt={1} mb={2}>
                                <SuiTypography
                                    variant="body1"
                                    color="body"
                                    opacity={0.6}
                                >
                                    {description(code)}
                                </SuiTypography>
                            </SuiBox>
                        </Grid>
                    </Grid>
                </Grid>
            </SuiBox>
        </PageLayout>
    );
}

export default ErrorGeneric;
